import React from 'react'
import './styles.scss'
import config from 'config'
import { useHistory } from 'react-router-dom'

interface Props {
  data: any
}

export const RankingTable = ({ data }: Props) => {
  const history = useHistory()

  return (
    <div className='ranking-table'>
      <div className='table-container club-name'>
        <table className='ui unstackable striped table'>
          <colgroup>
            <col span='1' style={{ width: '15%' }} />
            <col span='1' style={{ width: '5%' }} />
            <col span='1' style={{ width: '85%' }} />
          </colgroup>
          <thead>
            <tr className='header'>
              <th className='rank mobile hidden tablet hidden'>Rang</th>
              <th className='mobile only tablet only'>&nbsp;</th>
              <th className='caret' />
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {data.map((m, i) => (
              <tr
                key={'ranking-first-col-row-' + i}
                onClick={() => {
                  history.push(config.routes.matchesHistory + m.TeamID)
                }}
              >
                <td className='rank left aligned'>
                  <b>{m.CurrentRank}</b>
                </td>
                <td className='caret'>
                  {m.GoingUp ? (
                    <i className='ui icon caret up' />
                  ) : m.GoingDown ? (
                    <i className='ui icon caret down' />
                  ) : (
                    ''
                  )}
                </td>
                <td className='ellipsis'>
                  <span>
                    {m.TeamName}
                    {/* <i className='ui icon icon-green chevron right' /> */}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className='table-container scrollable'>
        <table className='ui unstackable striped table'>
          <thead>
            <tr>
              <th title='Tage gespielt'>#</th>
              <th title='Siege'>S</th>
              <th title='Unentschieden'>U</th>
              <th title='Niederlagen'>N</th>
              <th title='Strafpunkte'>F</th>
              <th title='Tore erzielt'>T+</th>
              <th title='Tore kassiert'>T-</th>
            </tr>
          </thead>
          <tbody>
            {data.map((m, i) => (
              <tr
                key={'ranking-second-col-row-' + i}
                onClick={() => {
                  history.push(config.routes.matchesHistory + m.TeamID)
                }}
              >
                <td>{m.DaysPlayed}</td>
                <td>{m.Wins}</td>
                <td>{m.Draws}</td>
                <td>{m.Losses}</td>
                <td>({m.FairPlayScore})</td>
                <td>{m.GoalsMade}</td>
                <td>{m.GoalsTaken}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className='table-container points'>
        <table className='ui unstackable striped table'>
          <thead>
            <tr>
              <th className='mobile hidden tablet hidden'>Punkte</th>
              <th title='Punkte' className='mobile only tablet only'>
                P
              </th>
            </tr>
          </thead>
          <tbody>
            {data.map((m, i) => (
              <tr
                key={'ranking-third-col-row-' + i}
                onClick={() => {
                  history.push(config.routes.matchesHistory + m.TeamID)
                }}
              >
                <td>
                  <b>{m.CurrentPoints}</b>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
